<template>
  <div class="nw-page">
    <b-container fluid class="py-4">
      <div class="page-header d-flex align-items-center justify-content-between mb-3">
        <div>
          <h2 class="mb-0">Депозит-адреса по сетям</h2>
          <small class="text-muted">
            Один адрес на сеть (цепь) принимает нативную монету и все её токены.
            Клиенты шлют крипту на эти адреса при пополнении.
          </small>
        </div>
        <b-button variant="outline-secondary" @click="load" :disabled="loading">
          <b-icon icon="arrow-clockwise" class="mr-1" /> Обновить
        </b-button>
      </div>

      <b-card class="shadow-soft">
        <div v-if="loading" class="text-center text-muted py-4">Загрузка…</div>
        <table v-else class="table nw-table mb-0">
          <thead>
            <tr>
              <th>Сеть</th>
              <th>Нативная монета</th>
              <th>Подтверждений</th>
              <th>Депозит-адрес</th>
              <th>Активна</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.networkCode">
              <td>
                <div class="nw-net">{{ row.displayName }}</div>
                <div class="nw-std">
                  {{ row.networkCode }}<span v-if="row.tokenStandard"> · {{ row.tokenStandard }}</span>
                </div>
              </td>
              <td>{{ row.nativeAsset }}</td>
              <td>{{ row.confirmationsRequired }}</td>
              <td>
                <input
                  type="text"
                  class="form-control nw-addr"
                  :class="{ 'nw-placeholder': isPlaceholder(row.address) }"
                  v-model.trim="row.address"
                  placeholder="Адрес не задан"
                />
              </td>
              <td>
                <b-form-checkbox v-model="row.isActive" switch />
              </td>
              <td class="text-right">
                <b-button size="sm" variant="primary" :disabled="row._busy" @click="save(row)">
                  {{ row._busy ? 'Сохраняю…' : 'Сохранить' }}
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import { apiDomain, getHeader } from '@/config/config';

export default {
  name: 'NetworkWallets',
  data() {
    return { rows: [], loading: false };
  },
  mounted() {
    this.load();
  },
  methods: {
    isPlaceholder(addr) {
      return !addr || String(addr).startsWith('REPLACE_');
    },
    async load() {
      this.loading = true;
      try {
        const { data } = await axios.get(`${apiDomain}/admin/network-wallets`, { headers: getHeader() });
        this.rows = (Array.isArray(data) ? data : []).map((r) => ({ ...r, address: r.address || '', _busy: false }));
      } catch (e) {
        this.toast('Не удалось загрузить адреса.', 'Ошибка', 'danger');
      } finally {
        this.loading = false;
      }
    },
    async save(row) {
      row._busy = true;
      try {
        await axios.put(
          `${apiDomain}/admin/network-wallets/${row.networkCode}`,
          { address: row.address, isActive: row.isActive },
          { headers: getHeader() },
        );
        this.toast(`Адрес для ${row.displayName} сохранён.`, 'Готово', 'success');
      } catch (e) {
        this.toast('Не удалось сохранить адрес.', 'Ошибка', 'danger');
      } finally {
        row._busy = false;
      }
    },
    toast(message, title, variant) {
      this.$bvToast.toast(message, {
        title, variant: variant || 'info', solid: true,
        toaster: 'b-toaster-top-center', autoHideDelay: 4000,
      });
    },
  },
};
</script>

<style scoped>
.nw-page { min-height: 100%; }
.nw-table th { font-size: 11px; text-transform: uppercase; letter-spacing: .04em; color: #6B7280; border-top: 0; }
.nw-table td { vertical-align: middle; }
.nw-net { font-weight: 700; }
.nw-std { font-size: 11px; color: #9aa0ad; }
.nw-addr { font-family: monospace; font-size: 12.5px; min-width: 320px; }
.nw-placeholder { color: #b45; }
.shadow-soft { box-shadow: 0 6px 24px rgba(0,0,0,.06); border-radius: 14px; }
</style>
